import { isAuthenticated, restorePersistedSession } from './loginService';

const PUBLIC_PATHS = [`${process.env.PUBLIC_URL}/anuncios/detalhe/`];

const normalizePath = (path: string) => path.replace(/\/+$/, '') || '/';

export const isCadastroPublicoRoute = () => {
	const pathname = normalizePath(window.location.pathname);
	const base = normalizePath(process.env.PUBLIC_URL || '');
	return pathname === `${base}/cadastro` || pathname === '/cadastro';
};

export const isPublicRoute = () => {
	if (isCadastroPublicoRoute()) return true;
	return PUBLIC_PATHS.some((path) => window.location.pathname.startsWith(path));
};

export const handleLogin = () => {
	// "Manter-me conectado": sem sessao nesta aba, tenta restaurar a persistida.
	if (!isAuthenticated()) {
		restorePersistedSession();
	}

	if (!isAuthenticated()) {
		return null;
	}

	return sessionStorage.getItem('sid');
};
